import { FlightCard, type FlightCardProps } from './flightCard'

export { FlightCard }
export type { FlightCardProps }
export default FlightCard
